/**
 * Mixin for auto-focusing search fields when dropdowns open
 * Provides a reusable method to focus search inputs in dropdown menus
 */
export const autoFocusMixin = {
  methods: {
    /**
     * Focuses search field when menu opens
     * @param {boolean} isOpen - Whether the menu is open
     * @param {boolean} showCondition - Whether search field is visible
     * @param {string} refName - Vue ref name for the search field
     * @param {number} [delay=100] - Delay in milliseconds before focusing
     */
    focusSearchOnMenuOpen(isOpen, showCondition, refName, delay = 100) {
      if (isOpen && showCondition) {
        this.$nextTick(() => {
          setTimeout(() => {
            try {
              const searchField = this.$refs[refName];
              if (searchField) {
                // Try direct focus method first (if available)
                if (typeof searchField.focus === "function") {
                  searchField.focus();
                } else if (searchField.$el) {
                  const input = searchField.$el.querySelector("input");
                  input?.focus();
                }
              }
            } catch (error) {
              console.warn(`Auto-focus failed for ${refName}:`, error);
            }
          }, delay);
        });
      }
    }
  }
};